<template>
    <v-layout row xs12 >
        <Loading :value="loading" ></Loading>
        <v-dialog
                v-model="dialogAjoutBudget"
                max-width="70%">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>Ajouter des Tarifications </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="closeDialog()">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-layout row>
                        <v-flex>
                            <data-tables :data="listeTypeTravaux" style="width: 100%">
                                <el-table-column prop="type" label="TYPE RESSOURCE" width="300">
                                    <template slot-scope="scope">
                                        <v-chip label text-color="white" color="primary">
                                            {{scope.row.type}}
                                        </v-chip>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="libelle" label="PRODUIT CONCERNE" width="300">
                                    <template slot-scope="scope">
                                        <v-chip label text-color="white" color="primary">
                                            {{scope.row.libelle}}
                                        </v-chip>
                                    </template>
                                </el-table-column>
                                 <el-table-column prop="unite" label="UNITE" width="300">
                                    <template slot-scope="scope">
                                        <v-chip label text-color="white" color="primary">
                                            {{scope.row.unite}}
                                        </v-chip>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="montant" label="PRIX D'ACHAT (FCFA)" width="200">
                                    <template slot-scope="scope">
                                        <v-chip label text-color="white" color="primary">
                                            {{scope.row.montant}}
                                        </v-chip>
                                    </template>
                                </el-table-column>
                            </data-tables>
                        </v-flex>
                    </v-layout>


                <!-- <div class="text-xs-right"> -->

                    <v-layout row class="text-xs-right">
                        <v-flex xs2>
                            <!-- <v-tooltip top> -->
                                <v-btn @click="closeDialog()"  slot="activator" icons block color="orange" dark>Anuller <v-icon right>remove_circle</v-icon></v-btn>
                                <!-- <v-btn slot="activator" icons block  @click="closeDialog()" dark>Anuller <v-icon right>remove_circle</v-icon></v-btn> -->
                                <!-- <span>Annuler</span> -->
                            <!-- </v-tooltip> -->
                        </v-flex>

                        <v-flex xs2>
                            <!-- <v-tooltip top> -->
                                <v-btn slot="activator" icons block color="green" @click="saveListe()" dark>Enregistrer <v-icon right>save</v-icon></v-btn>
                                <!-- <span>Enregistrer les produits</span>
                            </v-tooltip> -->
                        </v-flex>

                    </v-layout>
                    <!-- </div> -->

                </v-card-text>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
    import Loading from '@/components/Loading';
    export default {
        name: "LoadTarifFournExcel",
        components: {Loading},
        props:{
            listeTypeTravaux:
            {
                type: Array,
                default: null,
            },
            show:{
                type: Boolean,
                default: false
            },
            idFour:{
                type: Number,
            }
        },
        data(){
            return {
                domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
                user: JSON.parse(sessionStorage.getItem('userInfo')),
                roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
                droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
                dialogAjoutBudget: false,
                loading: false
            }
        },
        watch:{
            show: function(newValue,oldValue){
                if(newValue == true){
                    this.dialogAjoutBudget =true;
                }else{
                    this.dialogAjoutBudget =false;
                    // this.loadProduitFounRecent()
                    this.$emit("close");
                }

            }
        },
        methods: {
            saveListe(){
                // this.loadPage()
                 this.loading = true
                let succesEnreg = true;
                let url = this.domaine + "fournisseur/save/tarification/excel";
                let nbData = 10;
                let nbReq = 1;
                let ligne = null;

                let nbRest
                if (this.listeTypeTravaux.length > 10) {
                  nbData = 10;
                  nbReq = Math.round(this.listeTypeTravaux.length / nbData);
                  nbRest = this.listeTypeTravaux.length % nbData;
                  if (nbRest > 0) {
                    nbReq += 1;
                  }
                }
                for(let i=0; i<nbReq;i++)
                {
                    let initJ = i*nbData;
                    let finJ = (i + 1) * nbData;
                    let dataLot = [];
                    if(this.listeTypeTravaux.length > 0){
                        for(let j = initJ;j < finJ;j++){
                            if(this.listeTypeTravaux[j] == undefined){
                                break ;
                            }
                            dataLot.push(this.listeTypeTravaux[j]);
                        }
                    }
                    let data = new FormData();
                    for (let prop in dataLot) {
                        ligne = dataLot[prop];
                        data.append("option[type][]", ligne.type);
                        data.append("option[libelle][]", ligne.libelle);
                        data.append("option[unite][]", ligne.unite);
                        data.append("option[montant][]", ligne.montant);
                      }

                    // data.append('listeTypeTravaux', JSON.stringify(dataLot))
                    data.append('idUser', this.user.id)
                    data.append('fournisseur', this.idFour)


                    this.$http.post(url, data).then(
                        resp => {
                        this.loading = false
                            succesEnreg = false
                        // this.loadProduitFounRecent()

                             this.$emit("close");
                          this.dialogAjoutBudget = false
                           this.$notify({
                            title: "Enregistrement",
                            message: "La liste a ete enregistre avec succes",
                            type: "success",
                            position: "top-right",
                            duration: 7000
                        });
                        },
                        error => {
                            this.loading = false;
                            succesEnreg = false
                          this.dialogAjoutBudget = false
                            this.$message.error(
                                "Erreur lors de l'enregistrement des tarifs"
                            );


                        }
                    )
                }

                //  this.loading = true
                // const loading = this.$loading({
                //     lock: true,
                //     text: 'Veuillez patientez ...',
                //     spinner: 'el-icon-loading',
                //     background: 'rgba(0, 0, 0, 0.7)'
                // })
            },
             loadProduitFounRecent(){
                this.loading = true
                let url=""
                if (this.droitAcces.index_produit_fourn) {
                    url = this.domaine + 'fournisseur/' + this.idFour + '/index/produit/recent'
                } else{
                    url = this.domaine + 'fournisseur/' + this.idFour + '/index/' + this.user.id + '/produit/recent'
                }

                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.loading = false
                    }
                })
            },
             closeDialog() {
                this.$emit("close");
                // this.loadListeTravaux()
            },

        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/tierce/LoadTarifiFourn.vue